import {useAuth0} from "@auth0/auth0-react";
import {useContext, useEffect, useState} from "react";
import useJwtToken from "./useJwtToken";
import {SalvoContext} from "../contexts/SalvoContext";


export default function useClaims() {
    const { impersonatedClaims } = useContext(SalvoContext);
    const [claims, setClaims] = useState();
    const { isLoading: auth0Loading } = useAuth0();
    const token = useJwtToken();

    useEffect(() => {
        // async function extractClaims()
        // {
        //     try {
        //         const accessToken = await getAccessTokenSilently();
        //         const userClaims = jwtDecode(accessToken).permissions;
        //
        //         setClaims(userClaims)
        //     }
        //     catch (e)
        //     {
        //         console.error(e)
        //     }
        // }
        function extractClaims() {
            // Use impersonated user's claims if present
            const userClaims = impersonatedClaims != null
                ? impersonatedClaims
                : token?.permissions;

            setClaims(userClaims);
        }

        if (!auth0Loading && (token || impersonatedClaims)) {
            extractClaims();
        }
    }, [auth0Loading, token, impersonatedClaims]);

    const hasClaim = (claim) => {

        if (!claims)
            return false

        return claims.includes(claim) || claims.includes(claim + '-all')
    };

    const hasAnyOf = (...anyOf) => {
        return anyOf.some(claim => hasClaim(claim));
    }

    const hasAllOf = (...allOf) => {
        return allOf.every(claim => hasClaim(claim));
    }

    const isLoading = !claims


    return { claims, hasClaim, hasAnyOf, hasAllOf, isLoading };
}